export interface PublicShareApiRequest {
    share_id?: string;
    task_id?: string;
}

/** 报告分享访问范围。 */
export type ShareAccessScope = 'INVITED_ONLY' | 'ANYONE';

/** 分享成员类型。 */
export type ShareMemberType = 'OWNER' | 'INVITATION';

/** 邀请访问状态。 */
export type ShareInvitationStatus = 'INVITED' | 'ACCESSED';

/** 分享弹窗中的成员。 */
export interface ShareMemberResponse {
    member_type: ShareMemberType;
    member_id: string;
    display_name: string | null;
    email: string | null;
    status: ShareInvitationStatus | null;
    last_invited_at: number | null;
}

export interface PublicShareApiResponse {
    /**
     * 是否是分享页面`
     */
    public_share: boolean;
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 任务类型
     */
    task_type: string;
    /**
     * 是否是拥有者
     */
    owner: boolean;

    /** 分享访问范围。 */
    access_scope: ShareAccessScope;

    /** Owner 初始化弹窗时返回；Viewer 返回空数组。 */
    members: ShareMemberResponse[];
}

/** 单条邀请。 */
export interface ShareInvitationResponse {
    invitation_id: string;
    email: string;
    user_id: string | null;
    status: ShareInvitationStatus;
    last_invited_at: number;
}

/** 单个邮箱的邀请结果。 */
export interface ShareInvitationResultResponse {
    email: string;
    result: 'SUCCESS' | 'ALREADY_INVITED' | 'FAILED';
    error_code: 'INVALID_EMAIL' | 'MAIL_SEND_FAILED' | null;
    invitation: ShareInvitationResponse | null;
}

/** 批量邀请响应。 */
export interface ShareInvitationBatchResponse {
    results: ShareInvitationResultResponse[];
}

/** 分享范围更新响应。 */
export interface ShareAccessScopeResponse {
    share_id: string;
    access_scope: ShareAccessScope;
}

export const PublicShareApi = Symbol('PublicShareApi');

export interface PublicShareApi {
    getShareInit(data: PublicShareApiRequest): Promise<PublicShareApiResponse>;

    /** 批量邀请报告查看者。 */
    createInvitations(data: { share_id: string; emails: string[] }): Promise<ShareInvitationBatchResponse>;

    /** 重发邀请邮件。 */
    resendInvitation(data: { share_id: string; invitation_id: string }): Promise<ShareInvitationResultResponse>;

    /** 移除邀请。 */
    removeInvitation(data: { share_id: string; invitation_id: string }): Promise<boolean>;

    /** 更新分享访问范围。 */
    updateAccessScope(data: { share_id: string; access_scope: ShareAccessScope }): Promise<ShareAccessScopeResponse>;
}
